<template>
    <div
        class="basic-select"
        :tabindex="tabindex"
        @blur="closeOptions"
        ref="wrapper"
    >
        <div :class="['select-head', { 'has-error': hasError }]" ref="head">
            <span
                v-if="!optionShown && selectionMade != ''"
                @click.stop="inputIsClicked"
            >
                <div class="selected-area">
                    <p
                        :class="[
                            'flag-icon',
                            'flag',
                            `flag-icon-${selected.iso.toLowerCase()}`,
                        ]"
                    ></p>
                    <p>{{ selected.ext }}</p>
                </div>
            </span>
            <input
                type="text"
                ref="searchInput"
                v-model="search"
                @focus="showOptions"
                :placeholder="placeholder"
                @input="validate"
            />
        </div>

        <ul ref="optionList" class="">
            <li v-for="(option, index) in filtered" :key="index">
                <div @click="setSelection(option, index)">
                    <span
                        :class="[
                            'flag-icon',
                            'flag',
                            `flag-icon-${option.iso.toLowerCase()}`,
                        ]"
                    ></span>
                    {{ option.ext }}
                </div>
            </li>
        </ul>

        <p :class="['error-message', { 'has-error': hasError }]">
            {{ errorMessage }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
        },
        placeholder: {
            type: String,
        },
        tabindex: {
            type: Number,
            default: 0,
        },
        currValue: {
            type: Number,
        },
    },
    data() {
        return {
            showSelection: false,
            selectionMade: "",
            selected: {},
            search: "",
            optionShown: false,
            errorMessage: this.$t("Required"),
            hasError: false,
            activated: false,
        };
    },
    watch: {
        options: {
            immediate: true,
            handler(val) {
                if (!this.currValue || !this.options.length) return;
                this.selected = this.options.filter(
                    (c) => c.ext == this.currValue
                )[0];
                if (this.selected) {
                    this.selectionMade = this.selected.ext;
                }
            },
        },
        currValue: {
            immediate: true,
            handler(val) {
                if (!this.currValue || !this.options.length) return;
                this.selected = this.options.filter(
                    (c) => c.ext == this.currValue
                )[0];
                if (this.selected) {
                    this.selectionMade = this.selected.ext;
                }
            },
        },
    },
    methods: {
        test() {
            let l = this.$refs.optionList.classList;
            let h = this.$refs.head.classList;
            l.add("show");
            h.add("open-options");
            this.labelUp();
            this.optionShown = true;
        },
        inputIsClicked() {
            this.test();
            this.$refs.searchInput.focus();
        },
        showOptions() {
            this.activated = true;
            let l = this.$refs.optionList.classList;
            let h = this.$refs.head.classList;
            if (l.contains("show")) {
                this.closeOptions();
                this.optionShown = false;
            } else {
                l.add("show");
                h.add("open-options");
                this.labelUp();
                this.optionShown = true;
            }
        },
        validate() {
            this.search = this.search.replace(/[^0-9]/gi, "");
        },
        closeOptions() {
            if (this.$refs.optionList.classList) {
                this.$refs.optionList.classList.remove("show");
                this.$refs.head.classList.remove("open-options");
            }
            this.optionShown = false;
            this.setInput();
            if (this.selectionMade == "") {
                this.labelDown();
                if (this.activated) {
                    this.hasError = true;
                }
            }
        },
        setSelection(n, v) {
            this.selectionMade = n.ext;
            this.selected = n;
            this.$emit("value", n.ext);
            this.$emit("raw", v);
            this.$refs.optionList.classList.remove("show");
            this.$refs.head.classList.remove("open-options");
            this.labelUp();
            this.showSelection = true;
            this.optionShown = false;
            this.hasError = false;
        },
        setInput() {
            if (this.search != "") {
                let x = this.options.indexOf(Number(this.search));
                if (x > -1) {
                    this.setSelection(this.options[x], x);
                }
            }
        },
        labelUp() {
            this.$refs.head.classList.add("activated");
        },
        labelDown() {
            this.$refs.head.classList.remove("activated");
        },
        handleClicks(event) {
            if (!this.$el.contains(event.target)) {
                this.closeOptions();
            }
        },
        check() {
            if (this.selectionMade == "") {
                this.hasError = true;
            }
            return this.hasError;
        },
    },
    computed: {
        filtered() {
            if (this.search == "") {
                return this.options;
            } else {
                return this.options.filter((option) => {
                    return String(option.ext).match(this.search);
                });
            }
        },
    },
    mounted() {
        document.addEventListener("click", (event) => {
            this.handleClicks(event);
        });
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClicks);
    },
};
</script>

<style lang="scss" scoped>
$primary: #ffcb04;
$error: #eb6174;

.flag {
    margin-left: -5px;
    margin-right: 5px;
}

.selected-area {
    direction: ltr !important;

    p {
        display: inline-block;
    }
}

.basic-select {
    position: relative;
    cursor: pointer;

    &:focus {
        outline: none;
    }

    .select-head {
        height: 30px;
        border-bottom: 1px solid #ddd;
        color: #444444;
        font-size: 1em;
        font-weight: 500;
        transition: 0.25s ease-out;
        box-sizing: border-box;
        padding: 7px 7px 7px 16px;
        text-align: left;
        position: relative;
        text-transform: capitalize;

        span {
            position: absolute;
            height: calc(100% - 8px);
            display: inline-block;
            background-color: white;
            width: 100%;
            top: 7px;
            left: 10px;
            z-index: 5;
        }

        input {
            position: absolute;
            transition: 0.25s linear;
            height: calc(100% - 5px);
            display: inline-block;
            width: 82%;
            font-size: 1em;
            font-weight: bold;
            top: 5px;
            left: 15px;
            border: none;
            outline: none;

            &:focus,
            &:active {
                border: none !important;
                outline: none !important;
            }
        }
    }

    .select-head.activated {
        border-color: $primary;
    }

    .select-head.open-options {
        border-bottom-color: transparent;
    }

    .select-head.has-error {
        border-color: $error !important;
    }

    ul {
        overflow-y: auto;
        position: absolute;
        -ms-overflow-style: none;
        top: calc(100% - 20px);
        left: 0;
        display: none;
        background-color: white;
        box-shadow: 0 5px 25px #d7d7d7;
        width: 100%;
        border-radius: 0 0 5px 5px;
        z-index: 25;
        height: 195px;
        overflow-y: scroll;

        /* width */
        &::-webkit-scrollbar {
            width: 5px !important;
        }

        li {
            direction: ltr;
            text-align: left;
            padding: 7px 15px;
            border-top: 1px solid #d7d7d7;
            transition: 0.25s ease-out;
            color: #444444;
            text-transform: capitalize;

            &:first-child {
                border-top-color: transparent !important;
            }

            &:hover {
                background-color: #e6e6e6;
                color: black;
            }
        }
    }

    ul.show {
        display: block !important;
        width: 110px;
    }

    .error-message {
        transition: 0.25s linear;
        text-align: left;
        padding-left: 12px;
        color: $error;
        font-size: 13px;
        display: none;

        &.has-error {
            display: block !important;
        }
    }
}
</style>
